import { apiBusSchedBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const linesApiRoutes = {
    list: apiBusSchedBaseURL + "lines/",
};

export class LineAPI {
    static list(networkEdition) {
        const listUrl = `${linesApiRoutes.list}${networkEdition}`;

        return API.authenticatedRequest({
            url: listUrl ,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}
